export default __webpack_public_path__ + "static/media/style.6f1cd1af.svg";